<!-- <app-header></app-header> -->
<div>
  <main role="main" class="maincnt mainmrg faq-page">
    <!-- <div class="faqmainpage"> -->
    <div class="faqsect webview p-0">
      <div class="p-0 container-fluid text-center row m-0 section">
        <div class="faqnav navfixed">
          <nav class="navmnu">
            <div class="d-flex w-100" id="nav-tab" role="tablist">
              <a
                class="nav-item nav-link text-center active"
                href="javascript:void(0)"
                fragment="faq-tab1"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
                id="abouttabcontent"
                (click)="faqclk('abouttabcontent', 'abtview', 'faq-tab1')"
                ><span class="disimg"
                  ><img
                    src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569486808/Static%20images/Faq/abouttab_svtqmt.svg"
                    alt="Hand holding a lightning bolt illustrating that you've got the power in your hands"
                    title="I've got the power illustration"
                    width="50px"
                /></span>
                <font class="disblk"
                  >About <br />
                  Honest Gorilla</font
                >
              </a>
              <a
                class="nav-item nav-link"
                href="javascript:void(0)"
                fragment="faq-tab2"
                role="tab"
                aria-controls="nav-profile"
                aria-selected="false"
                id="deregulationtabcontent"
                (click)="
                  faqclk('deregulationtabcontent', 'Dreglaton', 'faq-tab2')
                "
                ><span class="disimg"
                  ><img
                    src="https://res.cloudinary.com/honest-gorilla/image/upload/v1588594943/Static%20images/Faq/deregulationtab_h280n6.svg"
                    alt="Clipboard illustration"
                    title="Clipboard illustration"
                    width="50px"
                /></span>
                <font class="disblk">Deregulation, <br />Explained</font>
              </a>
              <a
                class="nav-item nav-link"
                href="javascript:void(0)"
                fragment="faq-tab3"
                role="tab"
                aria-controls="nav-contact"
                aria-selected="false"
                id="switchingtabcontent"
                (click)="
                  faqclk('switchingtabcontent', 'switchingprcs', 'faq-tab3')
                "
                ><span class="disimg"
                  ><img
                    src="https://res.cloudinary.com/honest-gorilla/image/upload/v1588594638/Static%20images/Faq/switchingtab_woikeo.svg"
                    alt="Toggle switch illustration"
                    title="Toggle switch illustration"
                    width="60px"
                    class="mt-3"
                /></span>
                <font class="disblk">Switching <br />Process</font>
              </a>
              <a
                class="nav-item nav-link"
                href="javascript:void(0)"
                fragment="faq-tab4"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
                id="contracttabcontent"
                (click)="faqclk('contracttabcontent', 'cntrctterm', 'faq-tab4')"
                ><span class="disimg"
                  ><img
                    src="https://res.cloudinary.com/honest-gorilla/image/upload/v1588594811/Static%20images/Faq/contracttab_ezzzfs.svg"
                    alt="Illustration of bill copies"
                    title="Illustration of bill copies"
                    width="50px"
                /></span>
                <font class="disblk">Contract <br />Stuff</font>
              </a>
              <a
                class="nav-item nav-link"
                href="javascript:void(0)"
                fragment="faq-tab5"
                role="tab"
                aria-controls="nav-profile"
                aria-selected="false"
                id="givebacktabcontent"
                (click)="
                  faqclk('givebacktabcontent', 'givebacklight', 'faq-tab5')
                "
                ><span class="disimg"
                  ><img
                    src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569487017/Static%20images/Faq/givebacktab_csbur8.svg"
                    alt="Light of Unity Hot Air Balloon logo illustration"
                    title="Light of Unity Hot Air Balloon logo illustration"
                    width="50px"
                /></span>
                <font class="disblk">Giveback and <br />Light of Unity</font>
              </a>
              <a
                class="nav-item nav-link"
                href="javascript:void(0)"
                fragment="faq-tab6"
                role="tab"
                aria-controls="nav-contact"
                aria-selected="false"
                id="commercialtabcontent"
                (click)="
                  faqclk('commercialtabcontent', 'comerialengy', 'faq-tab6')
                "
                ><span class="disimg"
                  ><img
                    src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569487089/Static%20images/Faq/commercialtab_yux7wd.svg"
                    alt="Retail store illustration"
                    title="Retail store illustration"
                    width="60px"
                /></span>
                <font class="disblk"
                  >Commercial<br />
                  Energy</font
                >
              </a>
            </div>
          </nav>
          <div class="faq-main">
            <div class="disblk separeln w-100" id="faq-tab1">
              <div class="container">
                <h1 class="pt-4 pb-3 text-left faqhead" id="abtview">
                  About Honest Gorilla
                </h1>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    Tell me a little about yourself. What is Honest Gorilla?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Honest Gorilla is an energy brokerage with a purpose-driven
                    mission to transform electricity from a commodity service to
                    a means for social good. We are at the intersection of
                    technology and transparency because let’s face it, the
                    energy industry could use a little updating. We’re busy
                    creating an energy experience that is engaging, custom to
                    you and honest in pricing. We gain nothing by simply
                    displaying rates on a website, so we accompany and guide you
                    through the energy shopping process to help you secure an
                    energy plan that we feel best suits your building profile,
                    energy usage trends and lifestyle.
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    What problem is Honest Gorilla trying to solve?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Since the advent of energy deregulation, many have tried
                    their hand at creating a better mousetrap to capture market
                    share and acquire the greatest number of customers.
                    Unfortunately, the uninitiated or misinformed consumer has
                    paid the ultimate price of paying higher-than-average energy
                    bills each month. Customers have often come to us saying
                    they feel misled, misunderstood or manipulated. Their
                    decisions at that time were only as good as their options
                    (or understanding).
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    At Honest Gorilla, we are transforming the very business
                    model of energy. By taking a personalized approach to
                    shopping for a better energy plan, we are leveling the
                    playing field and bringing transparency to a confusing
                    marketplace. Our honest recommendation algorithm sorts
                    through all the fine print details and recommends only the
                    top offers we believe are worth considering.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    No more guesswork, grueling spreadsheets, or staring at a
                    buffet of options to choose. Our goal is to put an end to
                    your perpetual frustration each time it comes to shop for an
                    energy plan. The brilliant minds at Honest Gorilla have
                    reverse-engineered every portfolio company’s pricing, so you
                    don’t have to waste any more time trying to figure it out on
                    your own. Let Honest Gorilla be your advocate and go to work
                    for you. If it makes sense, it will save you dollars.
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    How is Honest Gorilla’s business different?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Energy providers, suppliers, marketers, advisors, brokers,
                    consultants --- whichever you may have used in the past ---
                    have traditionally placed profits before customers. This
                    means their profitability is more important than providing
                    customer service. That is why we take the time to get to
                    know you and how you use energy, so we can make an honest
                    recommendation of the energy plans that we believe to be
                    worth considering.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    We’ll send you notifications letting you know when it’s time
                    to renew. The energy companies call it “customer loyalty”
                    when your contract ends and your plan defaults to a variable
                    market rate. Instead, we call it opportunity, because it
                    gives us another chance to serve and remind you why you
                    chose to work with us in the first place.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    There is no monthly out-of-pocket fee to use our service.
                    Honest Gorilla was structured differently. We take a fixed
                    fee out of your monthly payments (fractions of a penny), pay
                    our agents and technology partners (along with some
                    unavoidable expenses), and use the rest to perfect our
                    algorithms and continue delivering value to our clients. In
                    essence, we treat the fees we earn from your energy
                    consumption as fuel to keep our company going and growing,
                    while setting aside a percentage of profits in our annual
                    ‘Giveback’ called ‘Light of Unity’.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    Giveback is a unique feature of Honest Gorilla, where each
                    year an allocated percentage of money is donated to Light of
                    Unity, our social impact initiative. Honest Gorilla uses the
                    fees earned from each client to fund the company’s
                    operations and growth plans, giving back any leftover money
                    to help people, in whatever capacity, to illuminate the
                    world.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    The more customers we have using our platform, the more we
                    get paid. It’s like a performance bonus or a management fee
                    that your private wealth manager earns every month to make
                    you money. Honest Gorilla works the same except we save you
                    money, which means you’re making money to save and spend on
                    yourself, your family and loved ones, doing things you
                    enjoy!
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    How does the honest recommendation algorithm work exactly?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Like the Coca-Cola secret recipe, there’s only a few people
                    that really know how the honest recommendation algorithm
                    works. From what we’re told, our engineers go through
                    meticulous detail reverse-engineering every portfolio energy
                    company’s pricing; modeling out each of the terms, charges
                    and fees included in the fine-print; then pair up your
                    responses to each of the questions in order to create a
                    usage profile; and run it through the algorithm to see which
                    plans to recommend.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    It was confusing when we heard it for the first time, you’re
                    not alone. But that’s how you see your average monthly bill
                    and price per kWh for each recommended plan. It’s a bit of a
                    different approach than just picking a plan by guessing
                    which usage tier you fall into and hoping you chose the
                    cheapest plan, or running your own spreadsheets (that’s if
                    you go to this extent).
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    Why aren’t you showing a long list of all the energy plans
                    offered?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    We love going through the Chinese buffet and getting
                    googly-eyed when we see all of the amazing food options to
                    choose. After doing that a few times, we observed there were
                    only a handful of items we put on our plates and even fewer
                    items we liked enough to go back for seconds and thirds.
                    Gleaning from those experiences at the buffet line, we
                    figured shopping for energy triggers the same human
                    behavior. Why display a bunch of options only to confuse and
                    frustrate customers! That is why we recommend a single plan,
                    but we know that not everyone will settle on the first thing
                    they see, so then we expand the selection and let you see a
                    few more. We don’t want to overwhelm you, just give you
                    enough options for you to make an informed decision so that
                    you feel you made the best decision.
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    How are you using the fees earned from my energy
                    consumption?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    So glad you asked! No matter how a company tries to spin the
                    way they get paid, nothing is free. Ultimately it is the
                    customer that pays for the service. Our fee is baked into
                    the price you pay, there is no separate bill or charge to
                    your credit card. This takes care of developing cool
                    technology, running an energy brokerage business (including
                    salaries, rent, and such), and hopefully making some profit
                    at the end of the day. This way, our desire for profit does
                    not conflict with our duty to provide valuable service and
                    keeps us all in alignment to help make this world a better,
                    brighter place.
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">How can I access Honest Gorilla?</h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Honest Gorilla is available either on your smart phone or
                    desktop computer through our website. There is no app that
                    you have to download to get the full experience. We
                    currently provide electricity solutions to residential,
                    commercial and industrial customers within ERCOT, the
                    deregulated parts of Texas. We’ll be rolling out additional
                    energy providers, services and states in the coming future.
                    Stay tuned!
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    When can I expect Honest Gorilla to be available in my
                    state?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    If you’re living outside of Texas in an area that is open to
                    retail energy competition, we’re on our way. Stay tuned and
                    follow us on Facebook, Twitter and Instagram.
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">How can I reach you guys?</h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    You can get in touch with us directly through the mobile or
                    desktop versions of our website. Look for the ‘Help’ button
                    on the lower right corner of this page. If you are
                    considering Honest Gorilla, feel free to get in touch with
                    us using the message box on this page.
                  </p>
                </section>
              </div>
            </div>
            <div class="disblk separeln w-100" id="faq-tab2">
              <div class="container">
                <h1 class="pt-5 pb-3 text-left faqhead" id="Dreglaton">
                  Deregulation, Explained
                </h1>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    I’m new to deregulation. What is it? How does it work?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Believe it or not but banks, railroads, airplanes and
                    telephone companies (even energy companies) were once
                    monopolies. There was only one company in each category you
                    could do business with. We had no choice as customers.
                    Matter of fact we weren’t even called that, we were referred
                    to as ‘rate-payers’. Because no matter the rate, we had to
                    pay their fee. We had nowhere to go and complain or shop to
                    find a better deal.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    If you’re on our website, chances are someone said you can
                    choose your energy company and that we could help you find a
                    better deal. Since you’d like to know more about energy
                    deregulation, we figured a picture is worth a thousand
                    words. Peep the infographic below.
                  </p>
                </section>
                <section class="text-center" id="imgHeight">
                  <div class="col-md-12 text-left px-0">
                    <div class="col-md-8 px-0">
                      <!-- <img src="assets/images/faq-deregulation.svg" width="80%"> -->
                      <img
                        src="https://res.cloudinary.com/honest-gorilla/image/upload/v1583295545/Static%20images/Faq/HG_Infographic_Customer_Facing_1_z7y7sp.png"
                        alt="Infographic illustration that shows how deregulation works and all of the key players"
                        title="Dereg 101 infographic"
                        class="my-4"
                      />
                    </div>
                  </div>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    Great, but how does deregulation really work?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    If you never liked art class and don’t like to interpret
                    those artsy pictures, we get it. You want the quick and
                    skinny version. Here it goes: when you choose an energy
                    provider, the local utility company or transmission
                    distribution provider does not change. The local utility
                    still owns the poles and wires, reads your meter, handles
                    all emergencies, and transmits and/or delivers energy to
                    home or business. The only thing that changes is whose logo
                    appears at the top of your bill, the price you pay for
                    energy and who you call for questions. That’s it.
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    Why are there so many energy providers? How do I know which
                    one to choose?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Energy deregulation spawned retail competition, and
                    competition created an environment where the strong strive
                    to survive. Then there are the fledglings that try to make
                    it, the up-and-comers and the savvy tech innovators that are
                    trying to change the world one kilowatt-hour at a time.
                    Regardless, everyone is fighting for your business, everyone
                    is touting they have the best options and cheapest plans.
                    But how do really know who’s telling the truth? Who can you
                    trust to tell you the truth? What is the truth? That is when
                    you can count on Honest Gorilla. It says it all in the name,
                    because ‘In a world of 800lb gorillas, we are honest.”
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    BTW, what’s up with your company name? Why Honest Gorilla?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    When we were coming up with a name to call ourselves, we
                    wanted to go with Honest Energy but it was already taken.
                    Then GoDaddy recommended ‘Honest Gorilla’ and immediately it
                    was love-at-first-sight. It speaks to the heart of the
                    company motto: ‘Shop for energy, save with confidence.’
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    Side note: according to Wikipedia, an 800lb gorilla (even
                    though gorillas in the wild never reach more than 600lbs),
                    is an expression for an organization so powerful that it can
                    act without regard to the rights of others or the law; or a
                    corporate entity that has such a large majority percentage
                    of whatever market they compete within that they can use
                    that strength to crush any would-be-competitors.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    Even though we are in the startup phase of our company’s
                    lifecycle, we did not want to be mistaken by the competition
                    as naïve. In a world where perception is reality, we felt
                    the only way for us to go toe-to-toe with the big boys (aka
                    800lb gorillas) of the energy industry was to be
                    transparent. We wanted to deliver value to our customers
                    where we felt everyone else was missing the mark. And so it
                    is said, that ‘In a world of 800lb gorillas, we are honest.’
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    Back to the deregulation stuff. What happens if my power
                    goes out? Who do I contact in the event of an outage or
                    emergency?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Just because you switched providers does not mean you’re
                    going to receive less quality service. It is commonly
                    understood everyone has refrigerators full of food, as well
                    as pets, animals and loved ones that have certain
                    requirements that demand electricity, and weather that can
                    directly affect us if we are without the AC or heater
                    running. Energy is an essential service and by law, everyone
                    is treated equally and without discrimination. If you happen
                    to experience a power outage, no need to panic. Simply call
                    your local utility provider and they will do their best to
                    restore power to your premise at their earliest convenience.
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    When I switch providers, will there be any noticeable
                    difference in the quality of service?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Switching energy providers isn’t like changing your home
                    phone service from landline to voice over IP (the internet)
                    and you experience those robotic or jittery sounds. Truth
                    is, there is no differentiation in quality of the energy
                    itself. All electrons were created equal. There are no
                    Gucci, Walmart or Coach electrons. They all flow down the
                    same poles and wires and right into your home or business.
                    Your lights won’t flicker or shine any brighter or dimmer
                    when you switch from Company X to Y, then Z and back to X.
                    You may be thinking the phone company said the same thing
                    too. Except the difference with energy is that it flows in a
                    very specific sinusoidal curve pattern (remember
                    trigonometry, sine and cosine) and if it’s off in any way,
                    then it will wreak major havoc. So technically, the quality
                    of your service can’t be any different or we’d all be in
                    trouble!
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    What about all this talk about going green. If I buy an
                    energy plan that says it comes from renewable sources (like
                    wind or solar), does it mean it comes directly to my
                    property?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Only if you have grid-tied windmills or solar panels
                    connected to your property via an inverter, then yes. You
                    are getting 100% Pure, Grade A, Non-GMO, Vegan, Certified
                    Organic renewable energy. Otherwise, our answer is no.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    When you see “renewable content” listed on an energy plan’s
                    Electricity Facts Label, that refers to the percentage of
                    energy coming from renewable sources of power generation. By
                    way of an analogy, think about it this way:
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    There are multiple fuel sources to generate electricity or
                    different types of power plants like nuclear, coal, natural
                    gas, hydro, wind, solar, and biomass to name the more common
                    types. When electricity is generated, each power plant pours
                    their electricity into a massive ocean (aka the grid). As
                    each power plant pours their electricity, it all gets mixed
                    together making it difficult to know the fuel source of a
                    particular sample. When you have a certain percentage of
                    each different fuel type mixed together, this is called
                    “generation mix.” In like manner, without getting any more
                    technical, each energy provider finds the right generation
                    mix in order to offer their customers competitive rates.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    Coming back to the question, unless explicitly stated in the
                    Electricity Facts Label, what you receive at your home or
                    business is a mixture of different fuel types. For example:
                    A% from nuclear, B% from natural gas, C% from coal and D%
                    from a combination of renewables.
                  </p>
                </section>
              </div>
            </div>

            <div class="disblk separeln w-100" id="faq-tab3">
              <div class="container">
                <h1 class="pt-5 pb-3 text-left faqhead mt-2" id="switchingprcs">
                  Switching Process
                </h1>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    Is there a charge to switch providers?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Technically, there is no charge to switch providers if
                    you’re within 14 days of your contract expiration date, or
                    if your contract has already expired. Be sure you meet
                    either of those 2 scenarios, otherwise you will be subject
                    to early termination fees assessed by your current energy
                    provider and those sometimes can be onerous. But, if you’re
                    moving-in to a new house, apartment, townhome, condo etc.,
                    there are different rates (i.e. move-in fees) depending on
                    how soon you need service turned on. These fees are subject
                    to change but typically don’t exceed a few dollars, each
                    utility’s fees are different.
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    What if I change my mind after a few days of signing up?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    If you happen to change your mind and decide you want to
                    cancel or go with another plan, then no worries. Just be
                    sure to read the Terms and Conditions so you know the
                    details. To avoid paying any early termination fees,
                    typically you have 3 days to cancel from your original date
                    of enrollment. Again, contact your energy provider to
                    explore your options and learn about their specific
                    requirements.
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    How long does it take to switch energy providers?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    It all depends on when your enrollment is accepted by ERCOT
                    (the governing body that oversees electricity deregulation
                    in Texas) and when it occurs in your meter reading cycle.
                    Generally, switching can take 1 to 2 billing cycles,
                    sometimes less if you process a “self-select switch date”
                    --- in which case you can select a date 14 days prior to
                    when your contract expires without penalty from your current
                    provider.
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    Will I experience any interruption in service? Do I have to
                    let my current provider know I am switching or pay my bill
                    even though I am leaving them?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Switching providers is a seamless process. Once you submit
                    your information on the Honest Gorilla website, the
                    computers will talk with each other to get make sure you get
                    switched over. If there’s ever a hiccup, you can ensure our
                    fine operational folks and those at your new energy provider
                    will work their Oz-like magic to get you onto their
                    platform.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    Whatever you do, please
                    <font class="font-weight-bold">do not</font> contact your
                    current energy provider letting them know you are switching,
                    there is no need to get them involved. We take care of
                    everything. If you have an outstanding bill, be sure to pay
                    up and bring your balance to zero. Otherwise, failing to do
                    so can delay your switch and/or confuse the entire process.
                    And no, you cannot get away from paying your bills. Your
                    current energy provider was kind enough to let you use their
                    energy for a full month before they billed you for it, so
                    make sure you pay the ‘final bill’. You don’t want any
                    hiccups or issues later down the road.
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    What if I (have to) move before my contract ends?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Just because you signed an energy contract does not mean
                    it’s the end of the world for you. Put it this way, if you
                    are moving to another area that is deregulated, then you can
                    request a “move-out, move-in” from your energy provider.
                    This allows you to take your current contract with you to
                    the new place and enjoy all of its benefits. If you’re
                    moving to somewhere that is not deregulated or you’re moving
                    into a situation where you will not be able to fulfil the
                    terms of your contract, in most cases, you’ll just need to
                    provide documentation showing proof and can avoid having to
                    pay an early termination fee. Don’t just take our word for
                    it, be sure to read the Terms and Conditions of your
                    agreement or contact your energy provider to be sure.
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    I used to have X company, but switched to Y and Z for a
                    while. Can I come back to X, or will that be weird?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    TBH nobody really cares. It’s not like you’re dating your
                    energy company. They’ll actually be excited to have you back
                    as a customer! (FYI, TBH means ‘to be honest’)
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    [ALERT: Technical question] I was told I cannot switch
                    providers because I have a switch-hold on my meter. What is
                    that and how can I get rid of it?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    A switch-hold is a mechanism or market transaction that
                    energy providers use to prevent customers from switching
                    providers when their service has been disconnected for
                    non-payment until they pay the outstanding balance. It keeps
                    customers from gaming the system by switching providers when
                    they don’t want to pay their energy bill. To get a
                    switch-hold removed, simply contact your energy provider and
                    show documentation that you are a new resident occupant and
                    not associated with the customer for which the switch-hold
                    was imposed.
                  </p>
                </section>
              </div>
            </div>
            <div class="disblk separeln w-100" id="faq-tab4">
              <div class="container">
                <h1 class="pt-5 pb-3 text-left faqhead" id="cntrctterm">
                  Contract Stuff
                </h1>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    Is there a “best” time to start shopping for a new energy
                    provider?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    When it’s your money on the line, you’re the best judge of
                    how, when and who to spend it with. But we don’t mind giving
                    you a couple of pointers to guide your decisions.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    (Pro Tip #1) We generally recommend you try and start (or
                    end) your energy contract between November and March. Try to
                    avoid signing an agreement that starts (or ends) between
                    April and October, those months are generally referred to as
                    “peak” and is when rates tend to increase or be the most
                    expensive (i.e. hurricane season, hot summer temps,
                    supply/demand etc.).
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    (Pro Tip #2) It’s a good matter of practice to keep an eye
                    on energy rates, especially if you locked in when rates were
                    “high.” If you’ve been keeping up with how much energy your
                    home or business consumes (if not, we can help), and know
                    how much is your early termination fee, then you could
                    consider breaking your contract to secure the new, lower
                    rate if it makes financial sense. You have to be very
                    careful when exercising this option to make sure you know
                    how much it would cost to leave, but if there’s enough money
                    to be saved, then it’s definitely worth considering.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    As tempting as it may sometimes be to “wait and see” what
                    prices will do tomorrow (or later this week), that strategy
                    may end up costing you in the end. When you see a good rate,
                    we generally recommend you lock it in because there’s no
                    guarantee how long that price will hold or change against
                    your favor.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    (Pro Tip #3) You save the most amount of money when choosing
                    the right energy plan, and it does not matter how many LED
                    lights, Argon-filled, double-paned windows, radiant heat
                    barrier, 14+ inches of attic insulation, smart thermostats,
                    or 16+ SEER HVAC system you may have. If you experience a
                    high rate at the wrong time, all that money you spent
                    upgrading your home could be awash. All it takes is a couple
                    months of high energy bills to wipe any savings you may have
                    been looking forward to or had realized. Let’s not be
                    mistaken though, making all those upgrades are great, but we
                    recommend you implement them when financially feasible.
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    I checked rates yesterday and they are different today. Why
                    are they constantly changing?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Energy rates are no different than fuel prices you find at
                    the local gas station. Factors that can affect price
                    volatility include geopolitical forces, economic conditions,
                    weather (extreme temperature and weather related events like
                    hurricanes, snowstorms) and general supply and demand. If
                    you really want to get a feel for this stuff and see how
                    electricity or natural gas has performed, then follow
                    natural gas futures contracts on the NYMEX. That is the best
                    indicator and underlying commodity for energy prices.
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    Why do you typically recommend fixed-rate contracts over
                    variable or indexed?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    When it comes to your home or business, we tend to be
                    risk-averse. Fixed rates come with certainty, security and
                    peace-of-mind knowing that your rate will not change, that’s
                    why like we them and view them very favorably. Your usage
                    will vary each month depending on your lifestyle, household
                    and preferences, but to the extent you can minimize risk,
                    it’s generally a good idea to secure a fixed-rate.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    Index or variable rates are good if we are in a down-market
                    and rates are declining, that’s about the only time they’re
                    a good idea. Or if you’re looking for a short-term solution
                    because your present situation won’t allow you to commit for
                    a longer term. Otherwise, just one month of unpredictable
                    weather, shortage of supply or increased demand could send
                    rates through the roof and give you a heart attack. To the
                    extent no one has yet discovered a crystal ball that
                    foretells the future, we recommend the boring yet safer
                    route of price certainty (aka fixed rate plans).
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    My credit isn’t all that great. I haven’t established credit
                    before. What are my options?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    No one’s credit score is perfect and, like our grades back
                    in school, it is something always in need of improvement.
                    Whether you have a social security number, poor credit or no
                    credit, have no fear because we have a solution for you.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    You could always pay a couple hundred dollars to post a
                    deposit, but who has that kind of money laying around?! With
                    pre-paid energy (which is only available in Texas), you can
                    get started with a low, upfront payment and have your power
                    turned on same day, in some cases. Pre-paid energy works
                    like a debit account. Whatever amount of money you put in
                    your account is how much energy you’re able to use (i.e.
                    fund your account with $25 and get $25 worth of
                    electricity). This will get the kids to turn off the lights
                    real quick when they leave a room! Not to mention it teaches
                    them good habits.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    You even receive daily notifications letting you know much
                    you spent or used and how much remains. This is a great way
                    to budget your cashflow, help the environment and build your
                    credit back up. It’s kinda like extra-credit back in school.
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    Can’t I just go to the energy provider’s website and sign up
                    there?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    There’s nothing holding you back to check others, but
                    chances are you’ll be right back here where you started. It
                    won’t take you long to find the value that Honest Gorilla
                    provides and the very frustration we had when we started
                    this company. We aren’t selling rates, we’re providing an
                    experience and opportunity for you to make a difference.
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    Lower prices? Your quote was higher than I found elsewhere.
                    What gives?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    We have injected technology to lower our cost of operations
                    to offer competitive rates. While our prices tend to be
                    cheaper than the more established market participants, we
                    recognize that may not always be the case. Energy companies
                    use different pricing models and algorithms to set their
                    rates, and on occasion our prices may be higher than someone
                    else’s. That’s just how numbers work statistically and we
                    understand that reality. If it’s any comfort, please
                    remember that any leftover money will be contributed to
                    Light of Unity, so go ahead and use Honest Gorilla anyway!
                    What are you waiting for? Let’s get started.
                  </p>
                </section>
              </div>
            </div>
            <div class="disblk separeln w-100" id="faq-tab5">
              <div class="container">
                <h1 class="pt-5 pb-3 text-left faqhead" id="givebacklight">
                  Giveback and Light of Unity
                </h1>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">What is this Giveback thing?</h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Energy brokering works by pooling small amounts of money
                    (commissions) earned from a large group of customers who
                    sign up for the service. Since our fees are based on how our
                    customers use energy, and aren’t directly involved with
                    provisioning customers (the part that actually bears the
                    risk of providing competitively priced energy service),
                    there is some money left-over after all expenses have been
                    paid. We take this money as profits. Instead of keeping this
                    money all to ourselves, we intend to pay it forward to help
                    bring positive social impact to local communities and global
                    initiatives.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    Light of Unity is our social impact initiative. We were
                    inspired by the quote, “So powerful is the light of unity
                    that it can illuminate the whole earth.” And so we have
                    taken that literally to heart. We want to be the spreaders
                    of goodwill and help shed light on any person, family,
                    entity or organization locally or globally whose light could
                    be further illumined.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    Many are choosing to spread the love and make this world a
                    better, bright place simply by using Honest Gorilla as their
                    conduit to finding a better energy plan. As our community
                    grows, our social impact becomes even stronger.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    Note: the Giveback is currently not recognized as a tax
                    deductible donation, sorry!
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    Why doesn’t Honest Gorilla donate to other charities?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Social impact is baked into the core of the business. It is
                    our core philosophy and the very reason for the founding of
                    Honest Gorilla. We could’ve partnered with various
                    charities, but we wanted to start something new and
                    different. We didn’t want to just send a check and get a
                    ‘thank you’ note in the mail. To giveback to our own
                    initiative is an opportunity for us to serve at the
                    grassroots. This allows us to create community, be hands-on
                    and connect with local and global community members in
                    impactful and memorable ways that we can then share and
                    inspire others.
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">When do you pay the Giveback?</h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    At the end of February each year, we recommend to the board
                    how much we’d like to Giveback and pay it on March 1st.
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    What happens to my Giveback if I cancel my contract?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Because the way our contract reads with each of our
                    portfolio energy providers, the allocation of profit towards
                    Giveback is based on the total number of active, paying
                    customers. If you cancel your contract, not only are we
                    penalized but we miss out on those fees we would’ve
                    otherwise collected.
                  </p>
                </section>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">Is the Giveback guaranteed?</h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    No. Giveback is a feature of our policy, and our intent is
                    to pay it every year, but considerations to overall
                    profitability, company viability and sustainability must
                    also be given. The decision to Giveback is at the sole
                    discretion of the board.
                  </p>
                </section>
              </div>
            </div>
            <div class="disblk footersection w-100" id="faq-tab6">
              <div class="container">
                <h1 class="pt-5 pb-3 text-left faqhead" id="comerialengy">
                  Commercial Energy
                </h1>
                <section class="mb-2 mt-2 text-left pb-2">
                  <h3 class="subhead">
                    Why does Honest Gorilla need copies of my energy bills? And
                    specifically, why two?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    The same way that a doctor checks your vital signs to see
                    how healthy you really are, the experts at Honest Gorilla
                    evaluate your energy bills to see how effectively your
                    business is using energy and identify how we can help you
                    manage your energy expenses. We are looking for trends and
                    patterns from one month to the next to see if anything has
                    changed, that is why one bill is simply not enough. Your
                    personal information is not included on your energy bills,
                    so no need to worry about that. We are mostly interested in
                    the numbers. Our analysts home in on things like your
                    service address, meter number, utility account number or
                    ESIID, the type of product, energy and demand charges,
                    payment history and contract expiration date.
                  </p>
                </section>
                <section class="mt-2 text-left pb-2">
                  <h3 class="subhead">
                    What is a Letter of Authorization (“LOA”) and why do I need
                    to sign it?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Letter of Authorization can sound real formal and
                    intimidating, but don’t fret, you’re not signing over the
                    rights to your business. It is NOT a contract. In layman
                    terms, the LOA is nothing more than a fancy way of calling
                    the form a permission slip. The LOA grants us permission to
                    access two things from your local utility provider: (i) how
                    much energy (i.e. supply) your business consumed over the
                    past 12 months, and (ii) how you consumed that energy (i.e.
                    demand). Once we have obtained and analyzed all of the data,
                    including the information we extrapolated from your energy
                    bills, we then use it to engage our energy providers in a
                    reverse-auction and have them compete for your business.
                  </p>
                </section>
                <section class="mt-2 text-left pb-2">
                  <h3 class="subhead">
                    I’ve heard of an auction, but what is a reverse-auction?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Instead of prices going up, as they do in a typical forward
                    auction, prices go down in a reverse-auction. Because we
                    have relationships with many energy providers, we make them
                    compete for your business. We effectively create a market
                    where competitive pressures force the energy providers to
                    offer their lowest and best prices to win your business.
                  </p>
                </section>
                <section class="mt-2 text-left pb-2">
                  <h3 class="subhead">
                    Why do you have relationships with multiple energy
                    providers?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Every client has different business objectives; no two
                    businesses are alike. Each business owner or operator
                    requires different terms, products, payment options and has
                    different credit history, therefore it is our goal to pair
                    clients with an energy provider that meets each client’s
                    needs. And, to take full advantage of our platform, leverage
                    and negotiating power, the more energy providers we have in
                    our portfolio the better it is for our customers. When there
                    are more energy providers, you win due to increased
                    competition.
                  </p>
                </section>
                <section class="mt-2 text-left pb-2">
                  <h3 class="subhead">
                    Can’t I negotiate energy prices myself? Why do I need an
                    energy advisor or broker?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Of course you can, but do you think you would get a better
                    deal than someone whose sole job is to negotiate and win
                    energy contracts? We often hear customers say, “I used to
                    just call up three energy providers, compare each quote and
                    choose the cheapest one.” That may work for some, but most
                    clients have been unsuccessful using that strategy and that
                    is why they turn to Honest Gorilla to help them source and
                    negotiate energy contracts on their behalf. Here’s a few
                    reasons why clients choose to work with us:
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    Have you ever bought something and then found out a short
                    while later that somewhere else was offering a better deal
                    for the same exact thing? It’s a not-so-good feeling knowing
                    that you left money on the table. Now, imagine having
                    knowledge of that other deal before you went shopping!
                    Having an energy broker or advisor works the same way. We
                    save you time and money. Here’s how:
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    (1) The same reason why your customers trust and repeatedly
                    give you business, analyzing energy data, shopping and
                    negotiating energy contracts is our business. That is
                    something we do all day, every day. We have subject matter
                    expertise because we have negotiated energy contracts for
                    plenty of customers, large and small.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    (2) Fail to choose the right plan and the wrong plan will
                    choose you. There’s more to it than just securing a fixed
                    rate, especially when you’re burning lots of energy.
                    Oftentimes predatory products can be disguised as friendly
                    low prices, and unless you know what you’re doing, you could
                    be taken advantage of. You don’t want to be faced with
                    questions about how you are going to keep your doors open or
                    staff employed due to high energy bills. When we price deals
                    for our clients, we take into consideration everything, not
                    just each of the pricing elements and lock-in a low rate for
                    all of your supply charges, but also your financial goals
                    and future plans for your business. Sounds complicating,
                    because it is. Just one or two months of high energy bills
                    and you could be up late at night trying to find answers to
                    some of your career’s hardest questions.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    (3) We know what prices have done historically, what prices
                    and products are currently being offered, and have some
                    level of market insight into what they could be doing in the
                    near future. We don’t claim to have a crystal ball, but if
                    past results can be an indication of future performance,
                    then we have a slight edge and can advise you accordingly;
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    (4) We have relationships with not just one or two energy
                    providers but many, and that makes us a clearinghouse of
                    sorts. Since we interface with a bunch of energy providers,
                    we have an advantage seeing see what products and pricing
                    everyone is offering all at once. Unless you like to shop,
                    after about the second or third request, it is easy to feel
                    overwhelmed or confused. So leave the shopping to the
                    experts.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    (5) Because of the volume of energy that we close on a
                    daily, weekly, monthly, yearly basis, we are able to
                    negotiate favorable terms for our clients and pass along
                    those savings. It’s the difference between buying a can of
                    your favorite soft drink at the hotel convenient store vs
                    going to a wholesale club and buying a case or pallet of the
                    same and comparing the per unit price. In the case for using
                    Honest Gorilla, you buy the amount you need for your
                    business except you pay competitive, low prices.
                  </p>
                </section>
                <section class="mt-2 text-left pb-2">
                  <h3 class="subhead">
                    What is the difference between fixed rate and variable or
                    indexed rate?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Having a fixed rate means that the energy charge is fixed
                    and is not subject to market volatility. No matter what the
                    season, weather pattern, or economic condition we are
                    experiencing, your price per unit of energy will always
                    remain the same. Of course, the total amount you will owe at
                    the end of the month will vary, as it depends on how much
                    energy you used, but the price you pay per unit of energy
                    will remain fixed.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    Contrary to a fixed rate which, in most cases, is known to
                    provide price stability and security, variable or indexed
                    rates vary each month. The energy charge is determined by
                    the cost of some underlying index, usually the natural gas
                    futures contracts traded on the NYMEX. And similar to the
                    stock market, the NYMEX is constantly changing. These
                    products are generally cheaper than fixed rates because they
                    transfer risk from the energy provider to the customer.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    Consulting with Honest Gorilla will help us better
                    understand your risk tolerance so that we can recommend a
                    solution that best caters to your needs.
                  </p>
                </section>
                <section class="mt-2 text-left pb-2">
                  <h3 class="subhead">
                    When is a good time to lock in a fixed rate vs signing up
                    for a variable or indexed rate?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Honest Gorilla will be able to consult with you as to what
                    product could make the most sense for your budget given your
                    particular circumstances and business objectives. For
                    educational purposes, however, fixed rates are a great
                    option for most businesses looking for price security and
                    certainty as they are typically not subject to change. It is
                    best to lock in when energy prices are on the rise. On the
                    other-hand, variable or index rates become attractive
                    options when the market is trending downward and prices are
                    notably decreasing. In essence, you want to ride the
                    rollercoaster down and lock-in when prices go up. It sounds
                    easy when reading it here, but timing these events and
                    foreseeing these circumstances is left to the energy gods
                    and carefully consulting one’s risk management protocol to
                    determine the preferred path forward.
                  </p>
                </section>
                <section class="mt-2 text-left pb-2">
                  <h3 class="subhead">
                    Can I switch now, even if I’m in a contract?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    The beautiful thing about commercial energy contracts is
                    that there is much more flexibility than there is with
                    residential contracts. With commercial contracts, if you see
                    that rates are low and you want to take advantage of it,
                    then you can sign a contract today to start one year into
                    the future. This implies you don’t have to terminate your
                    existing contract. You can ride out your current contract
                    and proceed with the knowledge that you have a great rate
                    waiting for you a year from now. This sounds amazing, we
                    know!
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    In case this sounds too good to be true or are slightly
                    confused, let’s play out an example to help you better
                    understand this concept of a Futures Contract or Forward
                    Start Date. Let’s say for instance that your current
                    contract will expire in six months’ time. Being the
                    opportunist that you are, you notice that prices have gone
                    down and you want to take advantage of today’s low rates.
                    Well, guess what….you can! You can sign a 12 or 24 month
                    contract today to start in six months from now. Talk about
                    taking advantage of market opportunities!
                  </p>
                </section>
                <section class="mt-2 text-left pb-2">
                  <h3 class="subhead">
                    Rates are low and I want to lock-in my rate. Can I get out
                    of my contract, or am I stuck?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    Yes and no. Buyer beware: you can always get out of your
                    contract, but you may be subject to paying an Early
                    Termination Fee (“ETF”). You will want to consult the
                    contract that you had previously signed to see how the ETF
                    is calculated and how much it will cost you to terminate
                    early. If you experience any difficulties figuring out this
                    information or calculating your ETF, we can always assist.
                    Depending on the market situation, it may be advisable to
                    pay the ETF and secure a lower rate today or doing a
                    blend-and-extend. There have been countless cases where
                    either scenario makes sense. We will be happy to do a
                    cost-benefit analysis to see how different scenarios will
                    play out and identify which strategy ultimately is to your
                    financial benefit.
                  </p>
                </section>
                <section class="mt-2 text-left pb-2">
                  <h3 class="subhead">What is a blend-and-extend?</h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    In some cases, it may not be financially feasible to pay a
                    large lump sum to offset the Early Termination Fee. Securing
                    a blend-and-extend contract can be a way to save money now,
                    without any out-of-pocket expense, and spread out the cost
                    of energy over a longer period of time, especially if on a
                    higher rate and noticed that rates have gone down.
                  </p>
                  <p class="faqtxt font-weight-normal-calibre">
                    Here’s how a blend-and-extend deal might work: let’s assume
                    that you’re currently paying $0.10 per kWh for electricity
                    and are into the second year of your three year contract.
                    Let’s say that your energy provider is projecting
                    electricity prices will drop next year to $0.06 per kWh. If
                    that’s the case, then you could extend your current contract
                    another year, lock in next year’s price of $0.06 per kWh,
                    and blend it with this year’s rate to pay only $0.08 per kWh
                    starting today and through the third year of the contract as
                    well. This would mean you’d be paying $0.02 less this year
                    but $0.02 more next year.
                  </p>
                </section>
                <section class="mt-2 text-left pb-2">
                  <h3 class="subhead">
                    What if my business gets acquired, we acquire another
                    company, move, add or close down some locations?
                  </h3>
                  <p class="faqtxt font-weight-normal-calibre">
                    That’s exactly why would want to count on Honest Gorilla…to
                    help you navigate through complex situations like these!
                    Ever tried selling a house “For sale by owner” and then
                    quickly realized that’s not your gig? We will serve as your
                    main point of contact throughout your relationship with us
                    and will interface with your energy provider to ensure your
                    business needs are met and to your satisfaction.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobileview p-3">
      <h1
        class="text-center font-weight-bold pinkclr mb-4"
        style="font-size: 46px; color: #ed1976"
      >
        FAQ
      </h1>
      <div
        class="panel-group pl-2"
        id="accordion"
        role="tablist"
        aria-multiselectable="true"
      >
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="heading-1">
            <h4 class="panel-title mb-0">
              <a
                role="button"
                class="main pb-2"
                data-toggle="collapse"
                data-parent="#accordion"
                href="#collapse-1"
                aria-expanded="false"
                aria-controls="collapse-1"
              >
                About Honest Gorilla
              </a>
            </h4>
          </div>
          <div
            id="collapse-1"
            class="panel-collapse collapse"
            role="tabpanel"
            aria-labelledby="heading-1"
          >
            <div class="panel-body p-0">
              <div
                class="panel-group"
                id="accordion-1"
                role="tablist"
                aria-multiselectable="true"
              >
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-1-1">
                    <h4 class="panel-title mb-0">
                      <a
                        role="button"
                        class="sub pb-2 pt-2 mbsubmenu"
                        data-toggle="collapse"
                        data-parent="#accordion-1"
                        href="#collapse-1-1"
                        aria-expanded="false"
                        aria-controls="collapse-1-1"
                      >
                        Tell me a little about yourself. What is Honest Gorilla?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-1-1"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-1-1"
                  >
                    <div class="panel-body p-0">
                      <p>
                        Honest Gorilla is an energy brokerage with a
                        purpose-driven mission to transform electricity from a
                        commodity service to a means for social good. We are at
                        the intersection of technology and transparency because
                        let’s face it, the energy industry could use a little
                        updating. We’re busy creating an energy experience that
                        is engaging, custom to you and honest in pricing. We
                        gain nothing by simply displaying rates on a website, so
                        we accompany and guide you through the energy shopping
                        process to help you secure an energy plan that we feel
                        best suits your building profile, energy usage trends
                        and lifestyle.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-1-2">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-1"
                        href="#collapse-1-2"
                        aria-expanded="false"
                        aria-controls="collapse-1-2"
                      >
                        What problem is Honest Gorilla trying to solve?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-1-2"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-1-2"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Since the advent of energy deregulation, many have tried
                        their hand at creating a better mousetrap to capture
                        market share and acquire the greatest number of
                        customers. Unfortunately, the uninitiated or misinformed
                        consumer has paid the ultimate price of paying
                        higher-than-average energy bills each month. Customers
                        have often come to us saying they feel misled,
                        misunderstood or manipulated. Their decisions at that
                        time were only as good as their options (or
                        understanding).
                      </p>
                      <p>
                        At Honest Gorilla, we are transforming the very business
                        model of energy. By taking a personalized approach to
                        shopping for a better energy plan, we are leveling the
                        playing field and bringing transparency to a confusing
                        marketplace. Our honest recommendation algorithm sorts
                        through all the fine print details and recommends only
                        the top offers we believe are worth considering.
                      </p>
                      <p>
                        No more guesswork, grueling spreadsheets, or staring at
                        a buffet of options to choose. Our goal is to put an end
                        to your perpetual frustration each time it comes to shop
                        for an energy plan. The brilliant minds at Honest
                        Gorilla have reverse-engineered every portfolio
                        company’s pricing, so you don’t have to waste any more
                        time trying to figure it out on your own. Let Honest
                        Gorilla be your advocate and go to work for you. If it
                        makes sense, it will save you dollars.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-1-3">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-1"
                        href="#collapse-1-3"
                        aria-expanded="false"
                        aria-controls="collapse-1-3"
                      >
                        How is Honest Gorilla’s business different?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-1-3"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-1-3"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Energy providers, suppliers, marketers, advisors,
                        brokers, consultants --- whichever you may have used in
                        the past --- have traditionally placed profits before
                        customers. This means their profitability is more
                        important than providing customer service. That is why
                        we take the time to get to know you and how you use
                        energy, so we can make an honest recommendation of the
                        energy plans that we believe to be worth considering.
                      </p>
                      <p>
                        We’ll send you notifications letting you know when it’s
                        time to renew. The energy companies call it “customer
                        loyalty” when your contract ends and your plan defaults
                        to a variable market rate. Instead, we call it
                        opportunity, because it gives us another chance to serve
                        and remind you why you chose to work with us in the
                        first place.
                      </p>
                      <p>
                        There is no monthly out-of-pocket fee to use our
                        service. Honest Gorilla was structured differently. We
                        take a fixed fee out of your monthly payments (fractions
                        of a penny), pay our agents and technology partners
                        (along with some unavoidable expenses), and use the rest
                        to perfect our algorithms and continue delivering value
                        to our clients. In essence, we treat the fees we earn
                        from your energy consumption as fuel to keep our company
                        going and growing, while setting aside a percentage of
                        profits in our annual ‘Giveback’ called ‘Light of
                        Unity’.
                      </p>
                      <p>
                        Giveback is a unique feature of Honest Gorilla, where
                        each year an allocated percentage of money is donated to
                        Light of Unity, our social impact initiative. Honest
                        Gorilla uses the fees earned from each client to fund
                        the company’s operations and growth plans, giving back
                        any leftover money to help people, in whatever capacity,
                        to illuminate the world.
                      </p>
                      <p>
                        The more customers we have using our platform, the more
                        we get paid. It’s like a performance bonus or a
                        management fee that your private wealth manager earns
                        every month to make you money. Honest Gorilla works the
                        same except we save you money, which means you’re making
                        money to save and spend on yourself, your family and
                        loved ones, doing things you enjoy!
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-1-4">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-1"
                        href="#collapse-1-4"
                        aria-expanded="false"
                        aria-controls="collapse-1-4"
                      >
                        How does the honest recommendation algorithm work
                        exactly?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-1-4"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-1-4"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Like the Coca-Cola secret recipe, there’s only a few
                        people that really know how the honest recommendation
                        algorithm works. From what we’re told, our engineers go
                        through meticulous detail reverse-engineering every
                        portfolio energy company’s pricing; modeling out each of
                        the terms, charges and fees included in the fine-print;
                        then pair up your responses to each of the questions in
                        order to create a usage profile; and run it through the
                        algorithm to see which plans to recommend.
                      </p>
                      <p>
                        It was confusing when we heard it for the first time,
                        you’re not alone. But that’s how you see your average
                        monthly bill and price per kWh for each recommended
                        plan. It’s a bit of a different approach than just
                        picking a plan by guessing which usage tier you fall
                        into and hoping you chose the cheapest plan, or running
                        your own spreadsheets (that’s if you go to this extent).
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-1-5">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-1"
                        href="#collapse-1-5"
                        aria-expanded="false"
                        aria-controls="collapse-1-5"
                      >
                        Why aren’t you showing a long list of all the energy
                        plans offered?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-1-5"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-1-5"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        We love going through the Chinese buffet and getting
                        googly-eyed when we see all of the amazing food options
                        to choose. After doing that a few times, we observed
                        there were only a handful of items we put on our plates
                        and even fewer items we liked enough to go back for
                        seconds and thirds. Gleaning from those experiences at
                        the buffet line, we figured shopping for energy triggers
                        the same human behavior. Why display a bunch of options
                        only to confuse and frustrate customers! That is why we
                        recommend a single plan, but we know that not everyone
                        will settle on the first thing they see, so then we
                        expand the selection and let you see a few more. We
                        don’t want to overwhelm you, just give you enough
                        options for you to make an informed decision so that you
                        feel you made the best decision.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-1-6">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-1"
                        href="#collapse-1-6"
                        aria-expanded="false"
                        aria-controls="collapse-1-6"
                      >
                        How are you using the fees earned from my energy
                        consumption?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-1-6"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-1-6"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        So glad you asked! No matter how a company tries to spin
                        the way they get paid, nothing is free. Ultimately it is
                        the customer that pays for the service. Our fee is baked
                        into the price you pay, there is no separate bill or
                        charge to your credit card. This takes care of
                        developing cool technology, running an energy brokerage
                        business (including salaries, rent, and such), and
                        hopefully making some profit at the end of the day. This
                        way, our desire for profit does not conflict with our
                        duty to provide valuable service and keeps us all in
                        alignment to help make this world a better, brighter
                        place.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-1-7">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-1"
                        href="#collapse-1-7"
                        aria-expanded="false"
                        aria-controls="collapse-1-7"
                      >
                        How can I access Honest Gorilla?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-1-7"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-1-7"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Honest Gorilla is available either on your smart phone
                        or desktop computer through our website. There is no app
                        that you have to download to get the full experience. We
                        currently provide electricity solutions to residential,
                        commercial and industrial customers within ERCOT, the
                        deregulated parts of Texas. We’ll be rolling out
                        additional energy providers, services and states in the
                        coming future. Stay tuned!
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-1-8">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-1"
                        href="#collapse-1-8"
                        aria-expanded="false"
                        aria-controls="collapse-1-8"
                      >
                        When can I expect Honest Gorilla to be available in my
                        state?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-1-8"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-1-8"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        If you’re living outside of Texas in an area that is
                        open to retail energy competition, we’re on our way.
                        Stay tuned and follow us on Facebook, Twitter and
                        Instagram.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-1-9">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-1"
                        href="#collapse-1-9"
                        aria-expanded="false"
                        aria-controls="collapse-1-9"
                      >
                        How can I reach you guys?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-1-9"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-1-9"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        You can get in touch with us directly through the mobile
                        or desktop versions of our website. Look for the ‘Help’
                        button on the lower right corner of this page. If you
                        are considering Honest Gorilla, feel free to get in
                        touch with us using the message box on this page.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="heading-1">
            <h4 class="panel-title mb-0">
              <a
                role="button"
                class="main pb-2"
                data-toggle="collapse"
                data-parent="#accordion"
                href="#collapse-2"
                aria-expanded="false"
                aria-controls="collapse-1"
              >
                Deregulation, Explained
              </a>
            </h4>
          </div>
          <div
            id="collapse-2"
            class="panel-collapse collapse"
            role="tabpanel"
            aria-labelledby="heading-2"
          >
            <div class="panel-body p-0">
              <div
                class="panel-group"
                id="accordion-2"
                role="tablist"
                aria-multiselectable="true"
              >
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-2-1">
                    <h4 class="panel-title mb-0">
                      <a
                        role="button"
                        class="sub pb-2 pt-2 mbsubmenu"
                        data-toggle="collapse"
                        data-parent="#accordion-2"
                        href="#collapse-2-1"
                        aria-expanded="false"
                        aria-controls="collapse-2-1"
                      >
                        I’m new to deregulation. What is it? How does it work?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-2-1"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-2-1"
                  >
                    <div class="panel-body p-0">
                      <p>
                        Believe it or not but banks, railroads, airplanes and
                        telephone companies (even energy companies) were once
                        monopolies. There was only one company in each category
                        you could do business with. We had no choice as
                        customers. Matter of fact we weren’t even called that,
                        we were referred to as ‘rate-payers’. Because no matter
                        the rate, we had to pay their fee. We had nowhere to go
                        and complain or shop to find a better deal.
                      </p>
                      <p>
                        If you’re on our website, chances are someone said you
                        can choose your energy company and that we could help
                        you find a better deal. Since you’d like to know more
                        about energy deregulation, we figured a picture is worth
                        a thousand words. Peep the infographic below.
                      </p>
                      <section class="text-center">
                        <!-- <img src="assets/images/faq-deregulation.svg" width="100%"> -->
                        <img
                          src="https://res.cloudinary.com/honest-gorilla/image/upload/v1583295545/Static%20images/Faq/HG_Infographic_Customer_Facing_1_z7y7sp.png"
                          alt="Infographic illustration that shows how deregulation works and all of the key players"
                          title="Dereg 101 infographic"
                          width="100%"
                        />
                      </section>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-2-2">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-2"
                        href="#collapse-2-2"
                        aria-expanded="false"
                        aria-controls="collapse-2-2"
                      >
                        Great, but how does deregulation really work?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-2-2"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-2-2"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        If you never liked art class and don’t like to interpret
                        those artsy pictures, we get it. You want the quick and
                        skinny version. Here it goes: when you choose an energy
                        provider, the local utility company or transmission
                        distribution provider does not change. The local utility
                        still owns the poles and wires, reads your meter,
                        handles all emergencies, and transmits and/or delivers
                        energy to home or business. The only thing that changes
                        is whose logo appears at the top of your bill, the price
                        you pay for energy and who you call for questions.
                        That’s it.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-2-3">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-2"
                        href="#collapse-2-3"
                        aria-expanded="false"
                        aria-controls="collapse-2-3"
                      >
                        Why are there so many energy providers? How do I know
                        which one to choose?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-2-3"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-2-3"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Energy deregulation spawned retail competition, and
                        competition created an environment where the strong
                        strive to survive. Then there are the fledglings that
                        try to make it, the up-and-comers and the savvy tech
                        innovators that are trying to change the world one
                        kilowatt-hour at a time. Regardless, everyone is
                        fighting for your business, everyone is touting they
                        have the best options and cheapest plans. But how do
                        really know who’s telling the truth? Who can you trust
                        to tell you the truth? What is the truth? That is when
                        you can count on Honest Gorilla. It says it all in the
                        name, because ‘In a world of 800lb gorillas, we are
                        honest.”
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-2-4">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-2"
                        href="#collapse-2-4"
                        aria-expanded="false"
                        aria-controls="collapse-2-4"
                      >
                        BTW, what’s up with your company name? Why Honest
                        Gorilla?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-2-4"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-2-4"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        When we were coming up with a name to call ourselves, we
                        wanted to go with Honest Energy but it was already
                        taken. Then GoDaddy recommended ‘Honest Gorilla’ and
                        immediately it was love-at-first-sight. It speaks to the
                        heart of the company motto: ‘Shop for energy, save with
                        confidence.’
                      </p>
                      <p>
                        Side note: according to Wikipedia, an 800lb gorilla
                        (even though gorillas in the wild never reach more than
                        600lbs), is an expression for an organization so
                        powerful that it can act without regard to the rights of
                        others or the law; or a corporate entity that has such a
                        large majority percentage of whatever market they
                        compete within that they can use that strength to crush
                        any would-be-competitors.
                      </p>
                      <p>
                        Even though we are in the startup phase of our company’s
                        lifecycle, we did not want to be mistaken by the
                        competition as naïve. In a world where perception is
                        reality, we felt the only way for us to go toe-to-toe
                        with the big boys (aka 800lb gorillas) of the energy
                        industry was to be transparent. We wanted to deliver
                        value to our customers where we felt everyone else was
                        missing the mark. And so it is said, that ‘In a world of
                        800lb gorillas, we are honest.’
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-2-5">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-2"
                        href="#collapse-2-5"
                        aria-expanded="false"
                        aria-controls="collapse-2-5"
                      >
                        Back to the deregulation stuff. What happens if my power
                        goes out? Who do I contact in the event of an outage or
                        emergency?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-2-5"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-2-5"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Just because you switched providers does not mean you’re
                        going to receive less quality service. It is commonly
                        understood everyone has refrigerators full of food, as
                        well as pets, animals and loved ones that have certain
                        requirements that demand electricity, and weather that
                        can directly affect us if we are without the AC or
                        heater running. Energy is an essential service and by
                        law, everyone is treated equally and without
                        discrimination. If you happen to experience a power
                        outage, no need to panic. Simply call your local utility
                        provider and they will do their best to restore power to
                        your premise at their earliest convenience.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-2-6">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-2"
                        href="#collapse-2-6"
                        aria-expanded="false"
                        aria-controls="collapse-2-6"
                      >
                        When I switch providers, will there be any noticeable
                        difference in the quality of service?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-2-6"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-2-6"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Switching energy providers isn’t like changing your home
                        phone service from landline to voice over IP (the
                        internet) and you experience those robotic or jittery
                        sounds. Truth is, there is no differentiation in quality
                        of the energy itself. All electrons were created equal.
                        There are no Gucci, Walmart or Coach electrons. They all
                        flow down the same poles and wires and right into your
                        home or business. Your lights won’t flicker or shine any
                        brighter or dimmer when you switch from Company X to Y,
                        then Z and back to X. You may be thinking the phone
                        company said the same thing too. Except the difference
                        with energy is that it flows in a very specific
                        sinusoidal curve pattern (remember trigonometry, sine
                        and cosine) and if it’s off in any way, then it will
                        wreak major havoc. So technically, the quality of your
                        service can’t be any different or we’d all be in
                        trouble!
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-2-7">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-2"
                        href="#collapse-2-7"
                        aria-expanded="false"
                        aria-controls="collapse-2-7"
                      >
                        What about all this talk about going green. If I buy an
                        energy plan that says it comes from renewable sources
                        (like wind or solar), does it mean it comes directly to
                        my property?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-2-7"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-2-7"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Only if you have grid-tied windmills or solar panels
                        connected to your property via an inverter, then yes.
                        You are getting 100% Pure, Grade A, Non-GMO, Vegan,
                        Certified Organic renewable energy. Otherwise, our
                        answer is no.
                      </p>
                      <p>
                        When you see “renewable content” listed on an energy
                        plan’s Electricity Facts Label, that refers to the
                        percentage of energy coming from renewable sources of
                        power generation. By way of an analogy, think about it
                        this way:
                      </p>
                      <p>
                        There are multiple fuel sources to generate electricity
                        or different types of power plants like nuclear, coal,
                        natural gas, hydro, wind, solar, and biomass to name the
                        more common types. When electricity is generated, each
                        power plant pours their electricity into a massive ocean
                        (aka the grid). As each power plant pours their
                        electricity, it all gets mixed together making it
                        difficult to know the fuel source of a particular
                        sample. When you have a certain percentage of each
                        different fuel type mixed together, this is called
                        “generation mix.” In like manner, without getting any
                        more technical, each energy provider finds the right
                        generation mix in order to offer their customers
                        competitive rates.
                      </p>
                      <p>
                        Coming back to the question, unless explicitly stated in
                        the Electricity Facts Label, what you receive at your
                        home or business is a mixture of different fuel types.
                        For example: A% from nuclear, B% from natural gas, C%
                        from coal and D% from a combination of renewables.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="heading-1">
            <h4 class="panel-title mb-0">
              <a
                role="button"
                class="main pb-2"
                data-toggle="collapse"
                data-parent="#accordion"
                href="#collapse-3"
                aria-expanded="false"
                aria-controls="collapse-3"
              >
                Switching Process
              </a>
            </h4>
          </div>
          <div
            id="collapse-3"
            class="panel-collapse collapse"
            role="tabpanel"
            aria-labelledby="heading-3"
          >
            <div class="panel-body p-0">
              <div
                class="panel-group"
                id="accordion-3"
                role="tablist"
                aria-multiselectable="true"
              >
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-3-1">
                    <h4 class="panel-title mb-0">
                      <a
                        role="button"
                        class="sub pb-2 pt-2 mbsubmenu"
                        data-toggle="collapse"
                        data-parent="#accordion-1"
                        href="#collapse-3-1"
                        aria-expanded="false"
                        aria-controls="collapse-3-1"
                      >
                        Is there a charge to switch providers?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-3-1"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-3-1"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Technically, there is no charge to switch providers if
                        you’re within 14 days of your contract expiration date,
                        or if your contract has already expired. Be sure you
                        meet either of those 2 scenarios, otherwise you will be
                        subject to early termination fees assessed by your
                        current energy provider and those sometimes can be
                        onerous. But, if you’re moving-in to a new house,
                        apartment, townhome, condo etc., there are different
                        rates (i.e. move-in fees) depending on how soon you need
                        service turned on. These fees are subject to change but
                        typically don’t exceed a few dollars, each utility’s
                        fees are different.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-3-2">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-2"
                        href="#collapse-3-2"
                        aria-expanded="false"
                        aria-controls="collapse-3-2"
                      >
                        What if I change my mind after a few days of signing up?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-3-2"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-3-2"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        If you happen to change your mind and decide you want to
                        cancel or go with another plan, then no worries. Just be
                        sure to read the Terms and Conditions so you know the
                        details. To avoid paying any early termination fees,
                        typically you have 3 days to cancel from your original
                        date of enrollment. Again, contact your energy provider
                        to explore your options and learn about their specific
                        requirements.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-3-3">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-2"
                        href="#collapse-3-3"
                        aria-expanded="false"
                        aria-controls="collapse-3-3"
                      >
                        How long does it take to switch energy providers?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-3-3"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-3-3"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        It all depends on when your enrollment is accepted by
                        ERCOT (the governing body that oversees electricity
                        deregulation in Texas) and when it occurs in your meter
                        reading cycle. Generally, switching can take 1 to 2
                        billing cycles, sometimes less if you process a
                        “self-select switch date” --- in which case you can
                        select a date 14 days prior to when your contract
                        expires without penalty from your current provider.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-3-4">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-2"
                        href="#collapse-3-4"
                        aria-expanded="false"
                        aria-controls="collapse-3-4"
                      >
                        Will I experience any interruption in service? Do I have
                        to let my current provider know I am switching or pay my
                        bill even though I am leaving them?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-3-4"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-3-4"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Switching providers is a seamless process. Once you
                        submit your information on the Honest Gorilla website,
                        the computers will talk with each other to get make sure
                        you get switched over. If there’s ever a hiccup, you can
                        ensure our fine operational folks and those at your new
                        energy provider will work their Oz-like magic to get you
                        onto their platform.
                      </p>
                      <p>
                        Whatever you do, please
                        <font class="font-weight-bold">do not</font> contact
                        your current energy provider letting them know you are
                        switching, there is no need to get them involved. We
                        take care of everything. If you have an outstanding
                        bill, be sure to pay up and bring your balance to zero.
                        Otherwise, failing to do so can delay your switch and/or
                        confuse the entire process. And no, you cannot get away
                        from paying your bills. Your current energy provider was
                        kind enough to let you use their energy for a full month
                        before they billed you for it, so make sure you pay the
                        ‘final bill’. You don’t want any hiccups or issues later
                        down the road.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-3-5">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-2"
                        href="#collapse-3-5"
                        aria-expanded="false"
                        aria-controls="collapse-3-5"
                      >
                        What if I (have to) move before my contract ends?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-3-5"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-3-5"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Just because you signed an energy contract does not mean
                        it’s the end of the world for you. Put it this way, if
                        you are moving to another area that is deregulated, then
                        you can request a “move-out, move-in” from your energy
                        provider. This allows you to take your current contract
                        with you to the new place and enjoy all of its benefits.
                        If you’re moving to somewhere that is not deregulated or
                        you’re moving into a situation where you will not be
                        able to fulfil the terms of your contract, in most
                        cases, you’ll just need to provide documentation showing
                        proof and can avoid having to pay an early termination
                        fee. Don’t just take our word for it, be sure to read
                        the Terms and Conditions of your agreement or contact
                        your energy provider to be sure.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-3-6">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-2"
                        href="#collapse-3-6"
                        aria-expanded="false"
                        aria-controls="collapse-3-6"
                      >
                        I used to have X company, but switched to Y and Z for a
                        while. Can I come back to X, or will that be weird?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-3-6"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-3-6"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        TBH nobody really cares. It’s not like you’re dating
                        your energy company. They’ll actually be excited to have
                        you back as a customer! (FYI, TBH means ‘to be honest’)
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-3-7">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-2"
                        href="#collapse-3-7"
                        aria-expanded="false"
                        aria-controls="collapse-3-7"
                      >
                        [ALERT: Technical question] I was told I cannot switch
                        providers because I have a switch-hold on my meter. What
                        is that and how can I get rid of it?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-3-7"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-3-7"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        A switch-hold is a mechanism or market transaction that
                        energy providers use to prevent customers from switching
                        providers when their service has been disconnected for
                        non-payment until they pay the outstanding balance. It
                        keeps customers from gaming the system by switching
                        providers when they don’t want to pay their energy bill.
                        To get a switch-hold removed, simply contact your energy
                        provider and show documentation that you are a new
                        resident occupant and not associated with the customer
                        for which the switch-hold was imposed.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="heading-4">
            <h4 class="panel-title mb-0">
              <a
                role="button"
                class="main pb-2"
                data-toggle="collapse"
                data-parent="#accordion"
                href="#collapse-4"
                aria-expanded="false"
                aria-controls="collapse-4"
              >
                Contract Stuff
              </a>
            </h4>
          </div>
          <div
            id="collapse-4"
            class="panel-collapse collapse"
            role="tabpanel"
            aria-labelledby="heading-4"
          >
            <div class="panel-body p-0">
              <div
                class="panel-group"
                id="accordion-4"
                role="tablist"
                aria-multiselectable="true"
              >
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-4-1">
                    <h4 class="panel-title mb-0">
                      <a
                        role="button"
                        class="sub pb-2 pt-2 mbsubmenu"
                        data-toggle="collapse"
                        data-parent="#accordion-1"
                        href="#collapse-4-1"
                        aria-expanded="false"
                        aria-controls="collapse-4-1"
                      >
                        Is there a “best” time to start shopping for a new
                        energy provider?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-4-1"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-4-1"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        When it’s your money on the line, you’re the best judge
                        of how, when and who to spend it with. But we don’t mind
                        giving you a couple of pointers to guide your decisions.
                      </p>
                      <p>
                        (Pro Tip #1) We generally recommend you try and start
                        (or end) your energy contract between November and
                        March. Try to avoid signing an agreement that starts (or
                        ends) between April and October, those months are
                        generally referred to as “peak” and is when rates tend
                        to increase or be the most expensive (i.e. hurricane
                        season, hot summer temps, supply/demand etc.).
                      </p>
                      <p>
                        (Pro Tip #2) It’s a good matter of practice to keep an
                        eye on energy rates, especially if you locked in when
                        rates were “high.” If you’ve been keeping up with how
                        much energy your home or business consumes (if not, we
                        can help), and know how much is your early termination
                        fee, then you could consider breaking your contract to
                        secure the new, lower rate if it makes financial sense.
                        You have to be very careful when exercising this option
                        to make sure you know how much it would cost to leave,
                        but if there’s enough money to be saved, then it’s
                        definitely worth considering.
                      </p>
                      <p>
                        As tempting as it may sometimes be to “wait and see”
                        what prices will do tomorrow (or later this week), that
                        strategy may end up costing you in the end. When you see
                        a good rate, we generally recommend you lock it in
                        because there’s no guarantee how long that price will
                        hold or change against your favor.
                      </p>
                      <p>
                        (Pro Tip #3) You save the most amount of money when
                        choosing the right energy plan, and it does not matter
                        how many LED lights, Argon-filled, double-paned windows,
                        radiant heat barrier, 14+ inches of attic insulation,
                        smart thermostats, or 16+ SEER HVAC system you may have.
                        If you experience a high rate at the wrong time, all
                        that money you spent upgrading your home could be awash.
                        All it takes is a couple months of high energy bills to
                        wipe any savings you may have been looking forward to or
                        had realized. Let’s not be mistaken though, making all
                        those upgrades are great, but we recommend you implement
                        them when financially feasible.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-4-2">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-2"
                        href="#collapse-4-2"
                        aria-expanded="false"
                        aria-controls="collapse-4-2"
                      >
                        I checked rates yesterday and they are different today.
                        Why are they constantly changing?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-4-2"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-4-2"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Energy rates are no different than fuel prices you find
                        at the local gas station. Factors that can affect price
                        volatility include geopolitical forces, economic
                        conditions, weather (extreme temperature and weather
                        related events like hurricanes, snowstorms) and general
                        supply and demand. If you really want to get a feel for
                        this stuff and see how electricity or natural gas has
                        performed, then follow natural gas futures contracts on
                        the NYMEX. That is the best indicator and underlying
                        commodity for energy prices.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-4-3">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-2"
                        href="#collapse-4-3"
                        aria-expanded="false"
                        aria-controls="collapse-4-3"
                      >
                        Why do you typically recommend fixed-rate contracts over
                        variable or indexed?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-4-3"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-4-3"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        When it comes to your home or business, we tend to be
                        risk-averse. Fixed rates come with certainty, security
                        and peace-of-mind knowing that your rate will not
                        change, that’s why like we them and view them very
                        favorably. Your usage will vary each month depending on
                        your lifestyle, household and preferences, but to the
                        extent you can minimize risk, it’s generally a good idea
                        to secure a fixed-rate.
                      </p>
                      <p>
                        Index or variable rates are good if we are in a
                        down-market and rates are declining, that’s about the
                        only time they’re a good idea. Or if you’re looking for
                        a short-term solution because your present situation
                        won’t allow you to commit for a longer term. Otherwise,
                        just one month of unpredictable weather, shortage of
                        supply or increased demand could send rates through the
                        roof and give you a heart attack. To the extent no one
                        has yet discovered a crystal ball that foretells the
                        future, we recommend the boring yet safer route of price
                        certainty (aka fixed rate plans).
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-4-4">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-2"
                        href="#collapse-4-4"
                        aria-expanded="false"
                        aria-controls="collapse-4-4"
                      >
                        My credit isn’t all that great. I haven’t established
                        credit before. What are my options?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-4-4"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-4-4"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        No one’s credit score is perfect and, like our grades
                        back in school, it is something always in need of
                        improvement. Whether you have a social security number,
                        poor credit or no credit, have no fear because we have a
                        solution for you.
                      </p>
                      <p>
                        You could always pay a couple hundred dollars to post a
                        deposit, but who has that kind of money laying around?!
                        With pre-paid energy (which is only available in Texas),
                        you can get started with a low, upfront payment and have
                        your power turned on same day, in some cases. Pre-paid
                        energy works like a debit account. Whatever amount of
                        money you put in your account is how much energy you’re
                        able to use (i.e. fund your account with $25 and get $25
                        worth of electricity). This will get the kids to turn
                        off the lights real quick when they leave a room! Not to
                        mention it teaches them good habits.
                      </p>
                      <p>
                        You even receive daily notifications letting you know
                        much you spent or used and how much remains. This is a
                        great way to budget your cashflow, help the environment
                        and build your credit back up. It’s kinda like
                        extra-credit back in school.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-4-5">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-2"
                        href="#collapse-4-5"
                        aria-expanded="false"
                        aria-controls="collapse-4-5"
                      >
                        Can’t I just go to the energy provider’s website and
                        sign up there?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-4-5"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-4-5"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        There’s nothing holding you back to check others, but
                        chances are you’ll be right back here where you started.
                        It won’t take you long to find the value that Honest
                        Gorilla provides and the very frustration we had when we
                        started this company. We aren’t selling rates, we’re
                        providing an experience and opportunity for you to make
                        a difference.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-4-6">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-2"
                        href="#collapse-4-6"
                        aria-expanded="false"
                        aria-controls="collapse-4-6"
                      >
                        Lower prices? Your quote was higher than I found
                        elsewhere. What gives?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-4-6"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-4-6"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        We have injected technology to lower our cost of
                        operations to offer competitive rates. While our prices
                        tend to be cheaper than the more established market
                        participants, we recognize that may not always be the
                        case. Energy companies use different pricing models and
                        algorithms to set their rates, and on occasion our
                        prices may be higher than someone else’s. That’s just
                        how numbers work statistically and we understand that
                        reality. If it’s any comfort, please remember that any
                        leftover money will be contributed to Light of Unity, so
                        go ahead and use Honest Gorilla anyway! What are you
                        waiting for? Let’s get started.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="heading-5">
            <h4 class="panel-title mb-0">
              <a
                role="button"
                class="main pb-2"
                data-toggle="collapse"
                data-parent="#accordion"
                href="#collapse-5"
                aria-expanded="false"
                aria-controls="collapse-5"
              >
                Giveback and Light of Unity
              </a>
            </h4>
          </div>
          <div
            id="collapse-5"
            class="panel-collapse collapse"
            role="tabpanel"
            aria-labelledby="heading-5"
          >
            <div class="panel-body p-0">
              <div
                class="panel-group"
                id="accordion-5"
                role="tablist"
                aria-multiselectable="true"
              >
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-5-1">
                    <h4 class="panel-title mb-0">
                      <a
                        role="button"
                        class="sub pb-2 pt-2 mbsubmenu"
                        data-toggle="collapse"
                        data-parent="#accordion-5"
                        href="#collapse-5-1"
                        aria-expanded="false"
                        aria-controls="collapse-5-1"
                      >
                        What is this Giveback thing?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-5-1"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-5-1"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Energy brokering works by pooling small amounts of money
                        (commissions) earned from a large group of customers who
                        sign up for the service. Since our fees are based on how
                        our customers use energy, and aren’t directly involved
                        with provisioning customers (the part that actually
                        bears the risk of providing competitively priced energy
                        service), there is some money left-over after all
                        expenses have been paid. We take this money as profits.
                        Instead of keeping this money all to ourselves, we
                        intend to pay it forward to help bring positive social
                        impact to local communities and global initiatives.
                      </p>
                      <p>
                        Light of Unity is our social impact initiative. We were
                        inspired by the quote, “So powerful is the light of
                        unity that it can illuminate the whole earth.” And so we
                        have taken that literally to heart. We want to be the
                        spreaders of goodwill and help shed light on any person,
                        family, entity or organization locally or globally whose
                        light could be further illumined.
                      </p>
                      <p>
                        Many are choosing to spread the love and make this world
                        a better, bright place simply by using Honest Gorilla as
                        their conduit to finding a better energy plan. As our
                        community grows, our social impact becomes even
                        stronger.
                      </p>
                      <p>
                        Note: the Giveback is currently not recognized as a tax
                        deductible donation, sorry!
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-5-2">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-5"
                        href="#collapse-5-2"
                        aria-expanded="false"
                        aria-controls="collapse-5-2"
                      >
                        Why doesn’t Honest Gorilla donate to other charities?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-5-2"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-5-2"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Social impact is baked into the core of the business. It
                        is our core philosophy and the very reason for the
                        founding of Honest Gorilla. We could’ve partnered with
                        various charities, but we wanted to start something new
                        and different. We didn’t want to just send a check and
                        get a ‘thank you’ note in the mail. To giveback to our
                        own initiative is an opportunity for us to serve at the
                        grassroots. This allows us to create community, be
                        hands-on and connect with local and global community
                        members in impactful and memorable ways that we can then
                        share and inspire others.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-5-3">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-5"
                        href="#collapse-5-3"
                        aria-expanded="false"
                        aria-controls="collapse-5-3"
                      >
                        When do you pay the Giveback?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-5-3"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-5-3"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        At the end of February each year, we recommend to the
                        board how much we’d like to Giveback and pay it on March
                        1st.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-5-4">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-5"
                        href="#collapse-5-4"
                        aria-expanded="false"
                        aria-controls="collapse-5-4"
                      >
                        What happens to my Giveback if I cancel my contract?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-5-4"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-5-4"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Because the way our contract reads with each of our
                        portfolio energy providers, the allocation of profit
                        towards Giveback is based on the total number of active,
                        paying customers. If you cancel your contract, not only
                        are we penalized but we miss out on those fees we
                        would’ve otherwise collected.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-5-5">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-5"
                        href="#collapse-5-5"
                        aria-expanded="false"
                        aria-controls="collapse-5-5"
                      >
                        Is the Giveback guaranteed?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-5-5"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-5-5"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        No. Giveback is a feature of our policy, and our intent
                        is to pay it every year, but considerations to overall
                        profitability, company viability and sustainability must
                        also be given. The decision to Giveback is at the sole
                        discretion of the board.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel panel-default">
          <div class="panel-heading" role="tab" id="heading-6">
            <h4 class="panel-title mb-0">
              <a
                role="button"
                class="main pb-2"
                data-toggle="collapse"
                data-parent="#accordion"
                href="#collapse-6"
                aria-expanded="false"
                aria-controls="collapse-6"
              >
                Commercial Energy
              </a>
            </h4>
          </div>
          <div
            id="collapse-6"
            class="panel-collapse collapse"
            role="tabpanel"
            aria-labelledby="heading-6"
          >
            <div class="panel-body p-0">
              <div
                class="panel-group"
                id="accordion-6"
                role="tablist"
                aria-multiselectable="true"
              >
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-6-1">
                    <h4 class="panel-title mb-0">
                      <a
                        role="button"
                        class="sub pb-2 pt-2 mbsubmenu"
                        data-toggle="collapse"
                        data-parent="#accordion-1"
                        href="#collapse-6-1"
                        aria-expanded="false"
                        aria-controls="collapse-6-1"
                      >
                        Why does Honest Gorilla need copies of my energy bills?
                        And specifically, why two?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-6-1"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-6-1"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        The same way that a doctor checks your vital signs to
                        see how healthy you really are, the experts at Honest
                        Gorilla evaluate your energy bills to see how
                        effectively your business is using energy and identify
                        how we can help you manage your energy expenses. We are
                        looking for trends and patterns from one month to the
                        next to see if anything has changed, that is why one
                        bill is simply not enough. Your personal information is
                        not included on your energy bills, so no need to worry
                        about that. We are mostly interested in the numbers. Our
                        analysts home in on things like your service address,
                        meter number, utility account number or ESIID, the type
                        of product, energy and demand charges, payment history
                        and contract expiration date.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-6-2">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-6"
                        href="#collapse-6-2"
                        aria-expanded="false"
                        aria-controls="collapse-1-2"
                      >
                        What is a Letter of Authorization (“LOA”) and why do I
                        need to sign it?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-6-2"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-6-2"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Letter of Authorization can sound real formal and
                        intimidating, but don’t fret, you’re not signing over
                        the rights to your business. It is NOT a contract. In
                        layman terms, the LOA is nothing more than a fancy way
                        of calling the form a permission slip. The LOA grants us
                        permission to access two things from your local utility
                        provider: (i) how much energy (i.e. supply) your
                        business consumed over the past 12 months, and (ii) how
                        you consumed that energy (i.e. demand). Once we have
                        obtained and analyzed all of the data, including the
                        information we extrapolated from your energy bills, we
                        then use it to engage our energy providers in a
                        reverse-auction and have them compete for your business.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-6-2">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-6"
                        href="#collapse-6-3"
                        aria-expanded="false"
                        aria-controls="collapse-1-3"
                      >
                        I’ve heard of an auction, but what is a reverse-auction?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-6-3"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-6-3"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Instead of prices going up, as they do in a typical
                        forward auction, prices go down in a reverse-auction.
                        Because we have relationships with many energy
                        providers, we make them compete for your business. We
                        effectively create a market where competitive pressures
                        force the energy providers to offer their lowest and
                        best prices to win your business.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-6-2">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-6"
                        href="#collapse-6-4"
                        aria-expanded="false"
                        aria-controls="collapse-1-4"
                      >
                        Why do you have relationships with multiple energy
                        providers?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-6-4"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-6-4"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Every client has different business objectives; no two
                        businesses are alike. Each business owner or operator
                        requires different terms, products, payment options and
                        has different credit history, therefore it is our goal
                        to pair clients with an energy provider that meets each
                        client’s needs. And, to take full advantage of our
                        platform, leverage and negotiating power, the more
                        energy providers we have in our portfolio the better it
                        is for our customers. When there are more energy
                        providers, you win due to increased competition.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-6-2">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-6"
                        href="#collapse-6-5"
                        aria-expanded="false"
                        aria-controls="collapse-1-5"
                      >
                        Can’t I negotiate energy prices myself? Why do I need an
                        energy advisor or broker?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-6-5"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-6-5"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Of course you can, but do you think you would get a
                        better deal than someone whose sole job is to negotiate
                        and win energy contracts? We often hear customers say,
                        “I used to just call up three energy providers, compare
                        each quote and choose the cheapest one.” That may work
                        for some, but most clients have been unsuccessful using
                        that strategy and that is why they turn to Honest
                        Gorilla to help them source and negotiate energy
                        contracts on their behalf. Here’s a few reasons why
                        clients choose to work with us:
                      </p>
                      <p>
                        Have you ever bought something and then found out a
                        short while later that somewhere else was offering a
                        better deal for the same exact thing? It’s a not-so-good
                        feeling knowing that you left money on the table. Now,
                        imagine having knowledge of that other deal before you
                        went shopping! Having an energy broker or advisor works
                        the same way. We save you time and money. Here’s how:
                      </p>
                      <p>
                        (1) The same reason why your customers trust and
                        repeatedly give you business, analyzing energy data,
                        shopping and negotiating energy contracts is our
                        business. That is something we do all day, every day. We
                        have subject matter expertise because we have negotiated
                        energy contracts for plenty of customers, large and
                        small.
                      </p>
                      <p>
                        (2) Fail to choose the right plan and the wrong plan
                        will choose you. There’s more to it than just securing a
                        fixed rate, especially when you’re burning lots of
                        energy. Oftentimes predatory products can be disguised
                        as friendly low prices, and unless you know what you’re
                        doing, you could be taken advantage of. You don’t want
                        to be faced with questions about how you are going to
                        keep your doors open or staff employed due to high
                        energy bills. When we price deals for our clients, we
                        take into consideration everything, not just each of the
                        pricing elements and lock-in a low rate for all of your
                        supply charges, but also your financial goals and future
                        plans for your business. Sounds complicating, because it
                        is. Just one or two months of high energy bills and you
                        could be up late at night trying to find answers to some
                        of your career’s hardest questions.
                      </p>
                      <p>
                        (3) We know what prices have done historically, what
                        prices and products are currently being offered, and
                        have some level of market insight into what they could
                        be doing in the near future. We don’t claim to have a
                        crystal ball, but if past results can be an indication
                        of future performance, then we have a slight edge and
                        can advise you accordingly;
                      </p>
                      <p>
                        (4) We have relationships with not just one or two
                        energy providers but many, and that makes us a
                        clearinghouse of sorts. Since we interface with a bunch
                        of energy providers, we have an advantage seeing see
                        what products and pricing everyone is offering all at
                        once. Unless you like to shop, after about the second or
                        third request, it is easy to feel overwhelmed or
                        confused. So leave the shopping to the experts.
                      </p>
                      <p>
                        (5) Because of the volume of energy that we close on a
                        daily, weekly, monthly, yearly basis, we are able to
                        negotiate favorable terms for our clients and pass along
                        those savings. It’s the difference between buying a can
                        of your favorite soft drink at the hotel convenient
                        store vs going to a wholesale club and buying a case or
                        pallet of the same and comparing the per unit price. In
                        the case for using Honest Gorilla, you buy the amount
                        you need for your business except you pay competitive,
                        low prices.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-6-2">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-6"
                        href="#collapse-6-6"
                        aria-expanded="false"
                        aria-controls="collapse-1-6"
                      >
                        What is the difference between fixed rate and variable
                        or indexed rate?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-6-6"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-6-6"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Having a fixed rate means that the energy charge is
                        fixed and is not subject to market volatility. No matter
                        what the season, weather pattern, or economic condition
                        we are experiencing, your price per unit of energy will
                        always remain the same. Of course, the total amount you
                        will owe at the end of the month will vary, as it
                        depends on how much energy you used, but the price you
                        pay per unit of energy will remain fixed.
                      </p>
                      <p>
                        Contrary to a fixed rate which, in most cases, is known
                        to provide price stability and security, variable or
                        indexed rates vary each month. The energy charge is
                        determined by the cost of some underlying index, usually
                        the natural gas futures contracts traded on the NYMEX.
                        And similar to the stock market, the NYMEX is constantly
                        changing. These products are generally cheaper than
                        fixed rates because they transfer risk from the energy
                        provider to the customer.
                      </p>
                      <p>
                        Consulting with Honest Gorilla will help us better
                        understand your risk tolerance so that we can recommend
                        a solution that best caters to your needs.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-6-2">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-6"
                        href="#collapse-6-7"
                        aria-expanded="false"
                        aria-controls="collapse-1-7"
                      >
                        When is a good time to lock in a fixed rate vs signing
                        up for a variable or indexed rate?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-6-7"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-6-7"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Honest Gorilla will be able to consult with you as to
                        what product could make the most sense for your budget
                        given your particular circumstances and business
                        objectives. For educational purposes, however, fixed
                        rates are a great option for most businesses looking for
                        price security and certainty as they are typically not
                        subject to change. It is best to lock in when energy
                        prices are on the rise. On the other-hand, variable or
                        index rates become attractive options when the market is
                        trending downward and prices are notably decreasing. In
                        essence, you want to ride the rollercoaster down and
                        lock-in when prices go up. It sounds easy when reading
                        it here, but timing these events and foreseeing these
                        circumstances is left to the energy gods and carefully
                        consulting one’s risk management protocol to determine
                        the preferred path forward.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-6-2">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-6"
                        href="#collapse-6-8"
                        aria-expanded="false"
                        aria-controls="collapse-1-8"
                      >
                        Can I switch now, even if I’m in a contract?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-6-8"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-6-8"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        The beautiful thing about commercial energy contracts is
                        that there is much more flexibility than there is with
                        residential contracts. With commercial contracts, if you
                        see that rates are low and you want to take advantage of
                        it, then you can sign a contract today to start one year
                        into the future. This implies you don’t have to
                        terminate your existing contract. You can ride out your
                        current contract and proceed with the knowledge that you
                        have a great rate waiting for you a year from now. This
                        sounds amazing, we know!
                      </p>
                      <p>
                        In case this sounds too good to be true or are slightly
                        confused, let’s play out an example to help you better
                        understand this concept of a Futures Contract or Forward
                        Start Date. Let’s say for instance that your current
                        contract will expire in six months’ time. Being the
                        opportunist that you are, you notice that prices have
                        gone down and you want to take advantage of today’s low
                        rates. Well, guess what….you can! You can sign a 12 or
                        24 month contract today to start in six months from now.
                        Talk about taking advantage of market opportunities!
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-6-2">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-6"
                        href="#collapse-6-9"
                        aria-expanded="false"
                        aria-controls="collapse-1-9"
                      >
                        Rates are low and I want to lock-in my rate. Can I get
                        out of my contract, or am I stuck?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-6-9"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-6-9"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        Yes and no. Buyer beware: you can always get out of your
                        contract, but you may be subject to paying an Early
                        Termination Fee (“ETF”). You will want to consult the
                        contract that you had previously signed to see how the
                        ETF is calculated and how much it will cost you to
                        terminate early. If you experience any difficulties
                        figuring out this information or calculating your ETF,
                        we can always assist. Depending on the market situation,
                        it may be advisable to pay the ETF and secure a lower
                        rate today or doing a blend-and-extend. There have been
                        countless cases where either scenario makes sense. We
                        will be happy to do a cost-benefit analysis to see how
                        different scenarios will play out and identify which
                        strategy ultimately is to your financial benefit.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-6-2">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-6"
                        href="#collapse-6-10"
                        aria-expanded="false"
                        aria-controls="collapse-1-10"
                      >
                        What is a blend-and-extend?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-6-10"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-6-10"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        In some cases, it may not be financially feasible to pay
                        a large lump sum to offset the Early Termination Fee.
                        Securing a blend-and-extend contract can be a way to
                        save money now, without any out-of-pocket expense, and
                        spread out the cost of energy over a longer period of
                        time, especially if on a higher rate and noticed that
                        rates have gone down.
                      </p>
                      <p>
                        Here’s how a blend-and-extend deal might work: let’s
                        assume that you’re currently paying $0.10 per kWh for
                        electricity and are into the second year of your three
                        year contract. Let’s say that your energy provider is
                        projecting electricity prices will drop next year to
                        $0.06 per kWh. If that’s the case, then you could extend
                        your current contract another year, lock in next year’s
                        price of $0.06 per kWh, and blend it with this year’s
                        rate to pay only $0.08 per kWh starting today and
                        through the third year of the contract as well. This
                        would mean you’d be paying $0.02 less this year but
                        $0.02 more next year.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="heading-6-2">
                    <h4 class="panel-title mb-0">
                      <a
                        class="collapsed sub pb-2 pt-2 mbsubmenu"
                        role="button"
                        data-toggle="collapse"
                        data-parent="#accordion-6"
                        href="#collapse-6-11"
                        aria-expanded="false"
                        aria-controls="collapse-1-11"
                      >
                        What if my business gets acquired, we acquire another
                        company, move, add or close down some locations?
                      </a>
                    </h4>
                  </div>
                  <div
                    id="collapse-6-11"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="heading-6-11"
                  >
                    <div class="panel-body pl-0 pr-0">
                      <p>
                        That’s exactly why would want to count on Honest
                        Gorilla…to help you navigate through complex situations
                        like these! Ever tried selling a house “For sale by
                        owner” and then quickly realized that’s not your gig? We
                        will serve as your main point of contact throughout your
                        relationship with us and will interface with your energy
                        provider to ensure your business needs are met and to
                        your satisfaction.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <!-- <app-footer></app-footer> -->
  <a href="javascript:void(0)" class="toplink webview">
    <img src="assets/images/arrow-up.svg" width="25px"
  /></a>
</div>
